import { FC, useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { Delete } from 'jbc-front/components/icons';
import Button from 'jbc-front/components/Button';
import { Modal } from 'jbc-front/components/presenters/ui/Modal';
import { useMutation } from '@/hooks/graphql/useMutation';
import { useNotify } from '@/hooks/useNotify';
import { RegularHealthCheckupReport } from '../../query';
import styles from './DeleteReport.scss';
import { DELETE_REGULAR_HEALTH_CHECKUP_REPORT, DeleteRegularHealthCheckupReportQueryVariables } from './query';

interface DeleteReportProps {
  report: RegularHealthCheckupReport;
  refetch: () => void;
  className?: string;
}

export const DeleteReport: FC<DeleteReportProps> = ({ report, refetch, className }) => {
  const notify = useNotify();

  const modalPortalRef = useRef<HTMLElement | null>(null);
  const [isOpen, setIsOpen] = useState(false);
  const handleCloseModal = () => setIsOpen(false);

  useEffect(() => {
    const el = document.createElement('div');
    modalPortalRef.current = el;
    document.body.appendChild(el);
    return () => {
      el.remove();
    };
  }, []);

  const [deleteRegularHealthCheckupReport, { loading: deleting }] = useMutation<
    unknown,
    DeleteRegularHealthCheckupReportQueryVariables
  >(DELETE_REGULAR_HEALTH_CHECKUP_REPORT);

  const handleSubmit = async () => {
    await deleteRegularHealthCheckupReport({
      variables: {
        input: {
          id: report.id
        }
      }
    });

    notify('削除しました', 'success');
    setIsOpen(false);
    refetch();
  };

  return (
    <>
      <span className={className} onClick={() => setIsOpen(true)}>
        <Delete size={20} />
      </span>
      {modalPortalRef.current &&
        createPortal(
          <Modal isOpen={isOpen} onClose={handleCloseModal}>
            <Modal.Header onClose={handleCloseModal}>削除確認</Modal.Header>
            <Modal.Body>
              <p className="u-mb20">
                <b>{report.title}</b> の定期健康診断結果報告を削除しますか？
              </p>
              <p className={styles.warning}>
                この手続に関連する電子申請を行っている場合は、その電子申請の情報もすべて削除されますのでご注意ください
              </p>
            </Modal.Body>
            <Modal.Footer className={styles.modalFooter}>
              <Button className={styles.footerButton} onClick={handleCloseModal}>
                いいえ
              </Button>
              <Button className={styles.footerButton} primary onClick={handleSubmit} disabled={deleting}>
                はい
              </Button>
            </Modal.Footer>
          </Modal>,
          modalPortalRef.current
        )}
    </>
  );
};
